import { render, staticRenderFns } from "./accountManage.vue?vue&type=template&id=1c42ff63"
import script from "./accountManage.vue?vue&type=script&lang=js"
export * from "./accountManage.vue?vue&type=script&lang=js"
import style0 from "./accountManage.vue?vue&type=style&index=0&id=1c42ff63&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports